import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { WindowStateActions } from './window.actions';
import { AuthTokenActions } from '../auth-token/auth-token.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { WindowStateEffects } from './window.effects';
import { ChatWindowStates } from '../../types/enum';

export const initialState: Readonly<string> = ChatWindowStates.INITIALSTATE;

export const windowStateFeature = createFeature({
  name: 'windowState',
  reducer: createReducer(
    initialState,
    on(WindowStateActions.openWindow, AuthTokenActions.startSession, () => {
      return ChatWindowStates.OPENED;
    }),
    on(WindowStateActions.requestToMinimizeWindow, () => {
      return ChatWindowStates.MINIMIZED;
    })
  ),
});

export const { selectWindowStateState } = windowStateFeature;

export function provideWindowFeature() {
  return makeEnvironmentProviders([
    provideState(windowStateFeature),
    provideEffects(WindowStateEffects),
  ]);
}
